import AppChannel from 'modules/channels/App';

export function appLogin(
    email,
    password,
    remember,
    redirectUrl,
    anonymousBasketUuid = null,
    distributionId = null,
    refresh = false
) {
    AppChannel.commands.execute('login', {
        username: email,
        password,
        remember,
        redirectUrl,
        anonymousBasketUuid,
        distributionId,
        refresh,
    });
}

export function appGoogleLogin(googleToken = null, options = {}) {
    AppChannel.commands.execute('login', {
        ...options,
        googleToken,
    });
}

export function appGoogleOneTapLogin(googleToken = null, options = {}) {
    AppChannel.commands.execute('login', {
        ...options,
        noRedirection: true,
        googleToken,
    });
}
